<template>
  <div class="home">
    <Banner/>
    <br/>
    <section class="hero is-primary">&nbsp;</section>

    <section class="section shifted">
      <div class="container">
        <div class="columns is-desktop">
          <div class="column is-two-thirds-desktop">
            <HomeCarousel/>
          </div>
          <div class="column is-clipped">
            <AnnouncementCard/>
          </div>
        </div>
      </div>
    </section>

    <section class="hero is-medium has-bg-img-2">
      <div class="hero-body">
        <div class="container has-text-centered">
          <nav class="level">
            <div class="level-item" v-for="(stat, index) in stats" :key="'member-' + index">
              <div>
                <p class="title has-text-primary is-spaced has-text-weight-bold">{{ stat.number }}</p>
                <prismic-rich-text :field="stat.heading" class="subtitle is-size-6"/>
              </div>
            </div>
          </nav><br class="is-hidden-mobile"/>

          <p class="subtitle is-size-5 is-size-6-mobile has-text-left-mobile"><prismic-rich-text :field="info.content"/></p>
          <router-link class="button is-link" to="about">關於本會</router-link>

        </div>
      </div>
    </section>

    <br/>
    <br/>
    <br/>
    <br/>
    <section class="hero is-primary">&nbsp;</section>

    <section class="section shifted">
      <div class="container ">
        <EventCard/>
        <div class="has-text-centered">
            <router-link class="button is-link" to="/events">更多活動新聞</router-link>
        </div>
        <br/>
      </div>
    </section>

  </div>
</template>

<script>
// @ is an alias to /src
import EventCard from '@/components/EventCard.vue';
import AnnouncementCard from '@/components/AnnouncementCard.vue';
import HomeCarousel from '@/components/HomeCarousel.vue';
import Banner from '@/components/Banner.vue';

export default {
  name: 'home',
  components: {
    EventCard,
    HomeCarousel,
    AnnouncementCard,
    Banner,
  },
  data() {
    return {
      info: [],
      stats: [],
    };
  },
  methods: {
    getContent() {
      this.$prismic.client.query(
        this.$prismic.Predicates.at('document.type', 'home-stats'),
      ).then((response) => {
        this.info = response.results[0].data;
        this.stats = response.results[0].data.items;
      });
    },

  },
  created() {
    this.getContent();
  },
};
</script>

<style lang="scss" scoped>
.has-bg-img-2 {
  background:
    // linear-gradient(0deg, rgba(255, 255, 255, 0.85), rgba(255, 255, 255, 0.85)),
    url("../assets/banner-bg-2.jpg");
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
}

.level-item {
  border-right: 0.15rem solid rgba(0, 0, 0, 0.2);

  .title {
    line-height: 1.5;
  }

  &:last-child {
    border: none;
  }

  @media screen and (max-width: 769px) {
    border: none;
  }
}

.shifted {
  margin: -7.5em auto 0 auto;

  @media screen and (max-width: 1087px) {
    margin-top: -7.5em;
  }
}

.subtitle {
  line-height: 1.5;
}
</style>
